export default "__VITE_ASSET__Dta0etZ2__"